import React from 'react';
import { Radio } from 'antd';
import { UnorderedListOutlined, AppstoreOutlined } from '@ant-design/icons';

const ViewModeToggle = ({ 
  value, 
  onChange,
  iconMode = {
    icon: <AppstoreOutlined />,
    label: '图标'
  },
  listMode = {
    icon: <UnorderedListOutlined />,
    label: '列表'
  }
}) => {
  return (
    <Radio.Group 
      value={value} 
      onChange={(e) => onChange(e.target.value)}
      buttonStyle="solid"
    >
      <Radio.Button value="icon">
        {iconMode.icon} {iconMode.label}
      </Radio.Button>
      <Radio.Button value="list">
        {listMode.icon} {listMode.label}
      </Radio.Button>
    </Radio.Group>
  );
};

export default ViewModeToggle;
